/* MIB — SS26 drops landing: waitlist forms + per-bag "Notify me" buttons. */
(function () {
  if (window.MIBSS26) return;
  window.MIBSS26 = true;

  var KEY_JOINED = 'mib-ss26-joined';
  var KEY_LISTS = 'mib-ss26-lists';
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function read(key, fallback) {
    try { var v = window.localStorage.getItem(key); return v ? JSON.parse(v) : fallback; } catch (e) { return fallback; }
  }
  function write(key, value) {
    try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  var lists = read(KEY_LISTS, {}) || {};
  var joined = read(KEY_JOINED, false) === true;
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function tagString(base) {
    var out = [base];
    Object.keys(lists).forEach(function (k) { if (lists[k]) out.push(base + '-' + k); });
    return out.join(', ');
  }

  /* ---- forms ---- */
  function markDone(form) {
    var input = form.querySelector('input[type=email]');
    var btn = form.querySelector('[data-ss26-submit]');
    var proof = form.querySelector('[data-ss26-proof]');
    var err = form.querySelector('[data-ss26-err]');
    form.classList.add('is-done');
    form.classList.remove('has-error');
    if (err) err.textContent = '';
    if (input) { input.disabled = true; input.removeAttribute('aria-invalid'); }
    if (btn) { btn.disabled = true; if (btn.dataset.done) btn.textContent = btn.dataset.done; }
    if (proof && proof.dataset.done) proof.textContent = proof.dataset.done;
  }

  function initForm(form) {
    if (form.dataset.ss26Ready) return;
    form.dataset.ss26Ready = '1';
    var input = form.querySelector('input[type=email]');
    var err = form.querySelector('[data-ss26-err]');
    var tags = form.querySelector('[data-ss26-tags]');
    if (err && err.textContent.trim() !== '') form.classList.add('has-error');

    form.addEventListener('submit', function (e) {
      var value = input ? input.value.trim() : '';
      if (!EMAIL.test(value)) {
        e.preventDefault();
        form.classList.add('has-error');
        if (err) err.textContent = err.dataset.invalid || '';
        if (input) { input.setAttribute('aria-invalid', 'true'); input.focus(); }
        return;
      }
      if (input) input.value = value;
      if (tags) tags.value = tagString(tags.dataset.base || 'waitlist-ss26');
    });
    if (input) {
      input.addEventListener('input', function () {
        if (!form.classList.contains('has-error')) return;
        form.classList.remove('has-error');
        input.removeAttribute('aria-invalid');
        if (err) err.textContent = '';
      });
    }
  }

  /* ---- per-bag buttons ---- */
  function paint(btn) {
    var on = !!lists[btn.dataset.ss26Bag];
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.textContent = on ? btn.dataset.labelOn : btn.dataset.labelOff;
  }

  function goToForm() {
    var form = document.querySelector('#Ss26Panel') || document.querySelector('[data-ss26-form]');
    if (!form) return;
    form.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    var input = form.querySelector('input[type=email]');
    if (input && !input.disabled) window.setTimeout(function () { input.focus({ preventScroll: true }); }, reduceMotion ? 0 : 500);
  }

  function initBag(btn) {
    if (btn.dataset.ss26Ready) return;
    btn.dataset.ss26Ready = '1';
    paint(btn);
    btn.addEventListener('click', function () {
      var key = btn.dataset.ss26Bag;
      lists[key] = !lists[key];
      write(KEY_LISTS, lists);
      document.querySelectorAll('[data-ss26-bag="' + key + '"]').forEach(paint);
      if (lists[key] && !joined) goToForm();
    });
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-ss26-form]').forEach(initForm);
    root.querySelectorAll('[data-ss26-bag]').forEach(initBag);
    if (joined) root.querySelectorAll('[data-ss26-form]').forEach(markDone);
  }

  function start() {
    /* Back from Shopify after a successful signup: ?customer_posted=true#<form id> */
    var posted = /[?&]customer_posted=true/.test(window.location.search);
    var target = null;
    if (posted && window.location.hash) {
      try { target = document.querySelector(window.location.hash); } catch (e) { target = null; }
    }
    var justJoined = !!(target && target.hasAttribute('data-ss26-form')) || !!document.querySelector('[data-ss26-form] [data-ss26-submit][disabled]');
    if (justJoined && !joined) {
      joined = true;
      write(KEY_JOINED, true);
      try {
        var picked = Object.keys(lists).filter(function (k) { return lists[k]; });
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
          Shopify.analytics.publish('mib_ss26_waitlist_joined', { bags: picked });
        }
        document.dispatchEvent(new CustomEvent('mib:ss26:joined', { detail: { bags: picked } }));
      } catch (e) {}
    }
    init();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
